/*
* Old C&L and event info page
*/
window.GoogleMapsApp = (function (window, document, undefined) {

    // Include Google Maps API
    function includeGoogleMapsAPI() {
        var js,
          fjs = document.getElementsByTagName('script')[0];

        if (!document.getElementById('gmap-api')) {
            js = document.createElement('script');
            js.id = 'gmap-api';
            js.setAttribute('async', '');
            js.src = "//maps.googleapis.com/maps/api/js?key=AIzaSyAURrPQGSKNcWhRPaO8UVq4A5EZ3V6QAXw&callback=window.GoogleMapsApp.startMapping";
            fjs.parentNode.insertBefore(js, fjs);
        }
    };

    var $mapCanvas = $('.wilhelmsen-map');
    if ($mapCanvas.length) {
        includeGoogleMapsAPI();
    }

    var startMapping = function () {
        $mapCanvas.each(function (i) {
            initMap($mapCanvas[i]);
        })
    }

    var wilhelmsenMapStyles = {
        simple: [
              {
                  "elementType": "geometry",
                  "stylers": [
                    {
                        "color": "#d1dde0"
                    }
                  ]
              },
              {
                  "elementType": "labels",
                  "stylers": [
                    {
                        "visibility": "off"
                    }
                  ]
              },
              {
                  "elementType": "labels.icon",
                  "stylers": [
                    {
                        "visibility": "off"
                    }
                  ]
              },
              {
                  "elementType": "labels.text.fill",
                  "stylers": [
                    {
                        "color": "#616161"
                    }
                  ]
              },
              {
                  "elementType": "labels.text.stroke",
                  "stylers": [
                    {
                        "color": "#f5f5f5"
                    }
                  ]
              },
              {
                  "featureType": "administrative",
                  "elementType": "geometry",
                  "stylers": [
                    {
                        "visibility": "off"
                    }
                  ]
              },
              {
                  "featureType": "administrative.land_parcel",
                  "elementType": "labels.text.fill",
                  "stylers": [
                    {
                        "color": "#bdbdbd"
                    }
                  ]
              },
              {
                  "featureType": "administrative.neighborhood",
                  "stylers": [
                    {
                        "visibility": "off"
                    }
                  ]
              },
              {
                  "featureType": "poi",
                  "stylers": [
                    {
                        "visibility": "off"
                    }
                  ]
              },
              {
                  "featureType": "poi",
                  "elementType": "geometry",
                  "stylers": [
                    {
                        "color": "#eeeeee"
                    }
                  ]
              },
              {
                  "featureType": "poi",
                  "elementType": "labels.text.fill",
                  "stylers": [
                    {
                        "color": "#757575"
                    }
                  ]
              },
              {
                  "featureType": "poi.park",
                  "elementType": "geometry",
                  "stylers": [
                    {
                        "color": "#e5e5e5"
                    }
                  ]
              },
              {
                  "featureType": "poi.park",
                  "elementType": "labels.text.fill",
                  "stylers": [
                    {
                        "color": "#9e9e9e"
                    }
                  ]
              },
              {
                  "featureType": "road",
                  "stylers": [
                    {
                        "visibility": "off"
                    }
                  ]
              },
              {
                  "featureType": "road",
                  "elementType": "geometry",
                  "stylers": [
                    {
                        "color": "#ffffff"
                    }
                  ]
              },
              {
                  "featureType": "road",
                  "elementType": "labels.icon",
                  "stylers": [
                    {
                        "visibility": "off"
                    }
                  ]
              },
              {
                  "featureType": "road.arterial",
                  "elementType": "labels.text.fill",
                  "stylers": [
                    {
                        "color": "#757575"
                    }
                  ]
              },
              {
                  "featureType": "road.highway",
                  "elementType": "geometry",
                  "stylers": [
                    {
                        "color": "#dadada"
                    }
                  ]
              },
              {
                  "featureType": "road.highway",
                  "elementType": "labels.text.fill",
                  "stylers": [
                    {
                        "color": "#616161"
                    }
                  ]
              },
              {
                  "featureType": "road.local",
                  "elementType": "labels.text.fill",
                  "stylers": [
                    {
                        "color": "#9e9e9e"
                    }
                  ]
              },
              {
                  "featureType": "transit",
                  "stylers": [
                    {
                        "visibility": "off"
                    }
                  ]
              },
              {
                  "featureType": "transit.line",
                  "elementType": "geometry",
                  "stylers": [
                    {
                        "color": "#e5e5e5"
                    }
                  ]
              },
              {
                  "featureType": "transit.station",
                  "elementType": "geometry",
                  "stylers": [
                    {
                        "color": "#eeeeee"
                    }
                  ]
              },
              {
                  "featureType": "water",
                  "elementType": "geometry",
                  "stylers": [
                    {
                        "color": "#f3f6f7"
                    }
                  ]
              },
              {
                  "featureType": "water",
                  "elementType": "labels.text.fill",
                  "stylers": [
                    {
                        "color": "#9e9e9e"
                    }
                  ]
              }
        ],
        detailed: [
        {
            "elementType": "geometry",
            "stylers": [
              {
                  "color": "#d1dde0"
              }
            ]
        },
        {
            "elementType": "labels.icon",
            "stylers": [
              {
                  "visibility": "on"
              }
            ]
        },
        {
            "elementType": "labels.text.fill",
            "stylers": [
              {
                  "color": "#666666"
              }
            ]
        },
        {
            "elementType": "labels.text.stroke",
            "stylers": [
              {
                  "color": "#ffffff"
              }
            ]
        },
        {
            "featureType": "administrative.land_parcel",
            "stylers": [
              {
                  "visibility": "off"
              }
            ]
        },
        {
            "featureType": "administrative.land_parcel",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                  "color": "#bdbdbd"
              }
            ]
        },
        {
            "featureType": "administrative.neighborhood",
            "stylers": [
              {
                  "visibility": "off"
              }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "geometry",
            "stylers": [
              {
                  "color": "#bbd2d7"
              }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "labels.text",
            "stylers": [
              {
                  "visibility": "off"
              }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                  "color": "#757575"
              }
            ]
        },
        {
            "featureType": "poi.park",
            "elementType": "geometry",
            "stylers": [
              {
                  "color": "#bbd2d7"
              }
            ]
        },
        {
            "featureType": "poi.park",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                  "color": "#9e9e9e"
              }
            ]
        },
        {
            "featureType": "road",
            "elementType": "geometry",
            "stylers": [
              {
                  "color": "#ffffff"
              }
            ]
        },
        {
            "featureType": "road",
            "elementType": "labels",
            "stylers": [
              {
                  "visibility": "off"
              }
            ]
        },
        {
            "featureType": "road.arterial",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                  "color": "#34525a"
              }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "geometry",
            "stylers": [
              {
                  "color": "#abc0c5"
              }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                  "color": "#666666"
              }
            ]
        },
        {
            "featureType": "road.local",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                  "color": "#abc0c5"
              }
            ]
        },
        {
            "featureType": "transit.line",
            "elementType": "geometry",
            "stylers": [
              {
                  "color": "#abc0c5"
              }
            ]
        },

        {
            "featureType": "transit.station",
            "elementType": "geometry",
            "stylers": [
              {
                  "color": "#bbd2d7"
              }
            ]
        },
        {
            "featureType": "water",
            "elementType": "geometry",
            "stylers": [
              {
                  "color": "#f3f6f7"
              }
            ]
        },
        {
            "featureType": "water",
            "elementType": "labels.text",
            "stylers": [
              {
                  "visibility": "off"
              }
            ]
        },
        {
            "featureType": "water",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                  "color": "#9e9e9e"
              }
            ]
        }
        ]
    };

    function initMap(mapCanvas) {
        var markers = new Array();

        var dotColor = "#e15f55"; // DA3A2F
        var dotColorActive = "#29588C";

        // get data from the html attr
        var mapType = $(mapCanvas).data('maptype');
        var mapLocations = $(mapCanvas).data('locations');
        var showBoxList = $(mapCanvas).data('show-box-list') || false;
        var appendMarkersToID = $(mapCanvas).data('append-markers-to-id') || "markers";
        var useClustering = $(mapCanvas).data('use-clustering') || false;


        var map = new google.maps.Map(mapCanvas, {
            center: { lat: 0, lng: 0 },
            zoom: 2,
            mapTypeControl: false,
            disableDefaultUI: true,
            backgroundColor: 'none',
            styles: wilhelmsenMapStyles[mapType]
        });

        var bounds = new google.maps.LatLngBounds();

        var infowindow = new google.maps.InfoWindow({
           maxWidth: 300
        });

        var locations = mapLocations;

        var icon = {
            // path: "M 12, 12 m -9, 0 a 9,9 0 1,0 18,0 a 9,9 0 1,0 -18,0",
            path: "M13.7,2.3C12.1,0.8,10.3,0,8,0S3.9,0.8,2.3,2.3C0.7,3.8,0,5.7,0,7.9c0,1.3,0.7,3.5,2,6.6s2.7,5.9,4,8.4 s2,3.8,2,3.7c0.2-0.4,0.5-0.9,0.9-1.6s1-1.9,1.9-3.7c0.9-1.8,1.7-3.5,2.4-5c0.7-1.5,1.3-3.1,1.9-4.7S16,8.7,16,7.9 C16,5.7,15.2,3.9,13.7,2.3z M9.7,9.6c-0.5,0.5-1.1,0.7-1.7,0.7s-1.3-0.2-1.7-0.7S5.6,8.5,5.6,7.9s0.2-1.2,0.7-1.7S7.4,5.5,8,5.5 c0.6,0,1.3,0.2,1.7,0.7c0.5,0.5,0.7,1,0.7,1.7S10.2,9.1,9.7,9.6z",
            fillColor: dotColor,
            fillOpacity: 1,
            scale: 1.25,
            strokeColor: '#ffffff',
            strokeWeight: 2,
            anchor: new google.maps.Point(8, 26.6)

        }

        /*
        If show box list is set to true
        */
        if (showBoxList == true) {
            for (var i = 0; i < locations.length; i++) {
                // Append a link to the markers DIV for each marker
                // The links are now done from EPI, so we dont need this any more.
                //$("#" + appendMarkersToID).append('<li class="map-interaction__nav-item"><a class="marker-link" data-markerid="' + i + '" href="' + locations[i][5] + '">' + locations[i][2] + '</a></li> ');

                var marker = new google.maps.Marker({
                    position: new google.maps.LatLng(locations[i][0], locations[i][1]),
                    map: map,
                    title: locations[i][2],
                    icon: icon
                });

                // Register a click event listener on the marker to display the corresponding infowindow content
                google.maps.event.addListener(marker, 'click', (function (marker, i) {
                    return function () {

                        var infowindowContent = "<h4 class='infowindow__title'>" + locations[i][2] + "</h4>" +
                                                "<p class='infowindow__text'>" + locations[i][3] + "</p>" +

                                                "<p class='infowindow__phone'><a href=tel:" + locations[i][4].replace(/\s/g, '') + ">" + locations[i][4] + "</a></p>" +
                                                "<a class='infowindow__link' href=" + locations[i][5] + ">Go to office</a>";
                        infowindow.setContent(infowindowContent);
                        infowindow.open(map, marker);

                        for (var j = 0; j < markers.length; j++) {
                            var symbol = markers[j].getIcon();
                            symbol.fillColor = dotColor;
                            markers[j].setIcon(symbol);
                        }

                        var symbol = this.getIcon();
                        symbol.fillColor = dotColorActive;
                        marker.setIcon(symbol);

                    }
                })(marker, i));

                // Add marker to markers array
                markers.push(marker);
            }

            for (var i = 0; i < markers.length; i++) {
                bounds.extend(markers[i].getPosition());
            }
            map.setCenter(bounds.getCenter());
            map.fitBounds(bounds);

            if (useClustering) {
                // https://googlemaps.github.io/js-marker-clusterer/docs/reference.html

                var clusterStyles = [
                    {
                        textColor: 'white',
						url: '/Static/prod/images/markerclusterer1.png',
                        height: 50,
                        width: 50
                    },
                    {
                        textColor: 'white',
						url: '/Static/prod/images/markerclusterer2.png',
                        height: 50,
                        width: 50
                    },
                    {
                        textColor: 'white',
						url: '/Static/prod/images/markerclusterer3.png',
                        height: 50,
                        width: 50
                    }
                ];

                var mcOptions = {
                    styles: clusterStyles
                };

                var markerCluster = new MarkerClusterer(map, markers, mcOptions);
            }

            // remove one zoom level to ensure no marker is on the edge.
            map.setZoom(map.getZoom() - 1);

            // Trigger a click event on each marker when the corresponding marker link is clicked

            if ($(window).width() > 700) {
                $('.marker-link').hover(function () {
                    google.maps.event.trigger(markers[$(this).data('markerid')], 'click');
                });
            }

        }

        else {
            for (var i = 0; i < locations.length; i++) {
                var marker = new google.maps.Marker({
                    position: new google.maps.LatLng(locations[i][0], locations[i][1]),
                    map: map,
                    title: locations[i][2],
                    icon: icon

                });

                google.maps.event.addListener(marker, 'click', (function (marker, i) {
                    return function () {

                        var infowindowContent = "<h4 class='infowindow__title'>" + locations[i][2] + "</h4>" +

                                                "<a class='infowindow__link' href=https://www.google.com/maps?saddr=My+Location&daddr=" + locations[i][0] + ',' + locations[i][1] + " target='_blank'>Get directions</a>";


                        infowindow.setContent(infowindowContent);
                        infowindow.open(map, marker);
                    }
                })(marker, i));

                markers.push(marker);
            }

            if (markers.length == 1) {
                map.setZoom(12);
                map.setCenter(marker.getPosition());
            } else {
                for (var i = 0; i < markers.length; i++) {
                    bounds.extend(markers[i].getPosition());
                }
                map.setCenter(bounds.getCenter());
                map.fitBounds(bounds);
                map.setZoom(map.getZoom() - 1);
            }
        }
    }


    // Make startMapping() public so we can pass it to
    // the Google Maps API callback param
    return {
        startMapping: startMapping
    };

})(window, document);


